{
    "coordinates": [
        55.60247570088774,
        -3.9005029778093103
    ],
    "tooltip": "Patrick Burn",
    "title": "Patrick Burn Formation",
    "country": "Scotland (UK)",
    "period": "Silurian",
    "alt": "TODO"
}
